<div *ngIf="noteBody$ | async as noteBody">
  <crm-collapsible-section [maxHeightPx]="100">
    <crm-activity-rich-text [richText]="noteBody"></crm-activity-rich-text>
  </crm-collapsible-section>
</div>
